// Cursuri.jsx
import { Link } from 'react-router-dom';
import './cursuri.css';
import bazeleconta from '../../imagesHome/bazeleconta.png';
import contafinanciara from '../../imagesHome/contafinanciara.png';
import { ProgressBarCourses } from '../progresbars/ProgressBarCourses';
import chaptericon from '../../imagesHome/chapter_icon.png';

const courses = [
  // Showlessons removed: Bazele contabilitatii course deleted
  {
    title: 'Contabilitate financiara',
    subtitle: 'Treci la urmatorul nivel in contabilitate',
    img: contafinanciara,
    progress: 65,
    thumbClass: 'thumb-orange',
    stats: [
      { icon: '📘', label: '300 lectii', color: 'green' },
      { icon: '📝', label: '4000 quiz-uri', color: 'blue' },
      { icon: '🧪', label: '150 aplicații', color: 'purple' },
      { icon: '🏅', label: '40 insigne', color: 'orange' },
    ],
    link: '/showlessonscf',
    cta: 'Continuă'
  }
];



const Cursuri = () => {
  return (
    <div className="courses-container">
      <div className="courses-title">
        <div>Cursuri disponibile</div>
        <div className='courses-subtitle'>Învață contabilitate pas cu pas</div>
      </div>

      <div className='courses-list'>
        {courses.map((course, idx) => (
          <div key={idx}>
            <div className='course-card-wrapper'>
              <div className='course-header'>
                <img src={course.img} alt={course.title} className={course.thumbClass === 'thumb-teal' ? 'course-image-bcc' : 'course-image-cfc'} />
                <div className='course-header-text'>
                  <div className='course-title'>{course.title}</div>
                  <div className='course-subtitle'>{course.subtitle}</div>
                </div>
              </div>

              <div className='course-body'>
                <div className='course-progress-container'>
                  <div className='course-progress-bar'>
                    <ProgressBarCourses progress={course.progress} />
                  </div>

                  <div className="course-badges">
                    {course.stats.map((s, i) => (
                      <div className="course-badge" key={i}>
                        <span>{s.icon}</span>
                        <span className={`badge-${s.color}`}> {s.label}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <div className='course-divider'></div>

                <div className='course-button-container'>
                  <Link to={course.link} state={course.state} className={course.thumbClass === 'thumb-teal' ? 'course-button-bc' : 'course-button-cf'}>
                    <div className="course-button-content">
                      <img src={chaptericon} className='course-button-icon' alt='start' />
                      <span className='course-button-text'>{course.cta}</span>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
            {idx < courses.length - 1 && <div className='course-section-divider'></div>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Cursuri;
